// Pinia store: google (migration from Vuex module)
import { defineStore } from 'pinia'
import { GOOGLE_SITE_KEY } from '../config.js'
import clientServices from '../clientServices.js'

export const useGoogleStore = defineStore('google', {
  state: () => ({
    siteKey: GOOGLE_SITE_KEY
  }),
  getters: {
    getSiteKey: (state) => state.siteKey
  },
  actions: {
    async checkCaptcha (captchaResponse) {
      const valid = await clientServices.checkCaptcha(captchaResponse)
      return valid
    }
  }
})
